import { useQuery } from '@tanstack/react-query'

import { useAuthenticatedUser } from '../../auth/hooks/useAuthenticatedUser'
import { fetchLinkedProjects } from '../services/fetchLinkedProjects'

export { useLinkedProjects }

const queryKey = 'projectdossier-linked-projects'

const useLinkedProjects = ({
  linkedProjectIds,
}: {
  linkedProjectIds: string[]
}) => {
  const { hasPermissions } = useAuthenticatedUser()

  const {
    data,
    isError,
    isPending: isLoading,
  } = useQuery({
    queryKey: [queryKey, linkedProjectIds],
    queryFn: () => fetchLinkedProjects({ linkedProjectIds }),
    enabled: hasPermissions,
    refetchOnMount: true,
  })

  return {
    isLoading,
    isError,
    data: data || [],
  }
}
